<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">解約予約の取り消し</span>
        </div>
        <div class="popup-content">
          <p class="txt">
            ライセンスの解約予約（次年）を取り消しますか？
          </p>
          <p class="txt">
            解約予約を取り消すライセンス数<span class="txt-num">{{selectProduct.cancel_license_number}}</span>
          </p>
          <div class="button mt32"
            @click.once="submit"
          >
            <span role="button" class="btn">解約の取消</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ServiceLicenseCancelCancel } from '@/logic/contract/ServiceLicenseCancelCancel'

export default defineComponent({
  setup (props, context) {
    return { ...ServiceLicenseCancelCancel(context) }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
  .txt-num{
    margin-left: 1em;
  }
</style>
